module.exports = new __parcel__URL__("upload.4eba1150.svg").toString();